import { resStatuses, statusCodes } from '@flowwai-frontend/shared/constants'
import { securedStringsCompare } from './HelperUtils'

export const getFormattedAPIError = (apiError: any, t: any) => {
   //TODO: need to add type
   let description = ''
   let errorConstant = ''
   let title: string = t('common:common.errorViewTitle')
   let errorCode: number = statusCodes.internalServerErrorCode
   if (apiError !== null && apiError !== undefined) {
      try {
         const parsedMessage: any = JSON.parse(apiError)
         let parsedError: any

         if (parsedMessage.data === undefined || parsedMessage.data === null) {
            // To handle case when we are directly returning backend  error message
            parsedError = parsedMessage
         } else {
            // To handle case when we are adding all the requests to backend error message
            parsedError = parsedMessage.data
         }

         if (parsedError !== undefined && parsedError !== null) {
            if (
               parsedError.message &&
               parsedError.message === resStatuses.requestTimedOut
            ) {
               title = t('common:common.errorViewTitle')
               description = t('common:common.errorViewDescription')
            }

            if (parsedError.response) {
               try {
                  const response = JSON.parse(parsedError.response)
                  const {
                     title: errorTitle,
                     description: errorDescription
                  } = response
                  title = errorTitle
                  description = errorDescription
               } catch (e) {
                  description = parsedError.response
               }
               errorConstant = parsedError.res_status
            }
            if (parsedError.http_status_code) {
               errorCode = parsedError.http_status_code
               errorConstant = parsedError.res_status
               if (
                  parsedError.http_status_code ===
                  statusCodes.noInternetErrorCode
               ) {
                  title = t('common:common.connectionLost')
                  description = t('common:common.internetConnection')
               }
            }
         }
      } catch (e) {
         if (apiError) {
            console.log(apiError)
         }
      }
   }

   if (description === null || description === '') {
      title = t('common:common.errorViewTitle')
      description = t('common:common.errorViewDescription')
   }
   const apiErrorResponse = {
      errorCode,
      title,
      description,
      errorConstant
   }
   return apiErrorResponse
}

export const getFormattedAPIErrorDescription = (apiError: any, t) => {
   //TODO: need to add types
   const error = getFormattedAPIError(apiError, t)
   return error.description
}

export function isAccessTokenExpiredResult(message: string) {
   const errorResponse = JSON.parse(message)
   let isAccessTokenExpired = false
   try {
      const { status, data } = errorResponse
      const { detail: failureMessage, res_status: resStatus } = data
      // infrastructure errors cases

      const isInvalidToken = securedStringsCompare(
         resStatus,
         resStatuses.invalidToken
      )
      const isInvalidUser = securedStringsCompare(
         resStatus,
         resStatuses.invalidUser
      )

      const isInvalidSessionToken = securedStringsCompare(
         resStatus,
         resStatuses.invalidSessionToken
      )

      if (
         status === statusCodes.badRequestErrorCode &&
         (isInvalidToken || isInvalidUser)
      ) {
         isAccessTokenExpired = true
      } else if (
         status === statusCodes.accessForbiddenErrorCode &&
         failureMessage &&
         resStatus === undefined
      ) {
         isAccessTokenExpired = true
      } else if (
         status === statusCodes.unAuthorizedErrorCode &&
         failureMessage &&
         resStatus === undefined
      ) {
         isAccessTokenExpired = true
      } else if (
         status === statusCodes.accessForbiddenErrorCode &&
         resStatus === resStatuses.notAuthorizedException
      ) {
         isAccessTokenExpired = true
      } else if (
         status === statusCodes.notFoundErrorCode &&
         resStatus === resStatuses.userNotFoundException
      ) {
         isAccessTokenExpired = true
      } else if (
         status === statusCodes.notFoundErrorCode &&
         isInvalidSessionToken
      ) {
         isAccessTokenExpired = true
      }
   } catch (e) {
      console.log('error in check error type', e)
   }

   return {
      isAccessTokenExpired
   }
}

export const getErrorMessageFromErrorType = (
   errorType?: string | null | undefined
): string => errorType?.replace(/([A-Z])/g, ' $1') ?? 'Something went wrong'
